var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-link',{ref:"reference",staticClass:"gfm gfm-milestone",attrs:{"data-reference-type":"milestone","data-original":`%\"${_vm.data.title}\"`,"title":_vm.data.title,"data-project":_vm.project,"data-milestone":_vm.data.id,"href":_vm.data.webPath}},[_vm._v("%"+_vm._s(_vm.data.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }